import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-wams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { ViewApplicationProfessionalBodiesWamsConstants } from "./view-application-professional-bodies-wams.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { ViewApplicationConstants } from "../../../shared/view-application.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationProfessionalBodiesWamsComponent = class ViewApplicationProfessionalBodiesWamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    recipientService;
    appController;
    changeDetectorRef;
    routerParamsService;
    professionalBodiesForm;
    professionalBodiesFormControl = ViewApplicationProfessionalBodiesWamsConstants.PROFESSIONAL_BODIES_FORM_CONTROL;
    stepHeader;
    markImplementingAgentAsNotApplicableLabel = ViewApplicationProfessionalBodiesWamsConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableLabel = ViewApplicationProfessionalBodiesWamsConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markContractorAsNotApplicableLabel = ViewApplicationProfessionalBodiesWamsConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    implementingAgentFormControlName = ViewApplicationProfessionalBodiesWamsConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = ViewApplicationProfessionalBodiesWamsConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = ViewApplicationProfessionalBodiesWamsConstants.RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME;
    showImplementingAgent = false;
    showEngineer = false;
    showContractor = false;
    implementingAgentDisableFilterBy = true;
    implementingAgentDisableEditing = true;
    implementingAgentGroups = [];
    implementingAgentLabel = ViewApplicationProfessionalBodiesWamsConstants.IMPLEMENTING_AGENT_LABEL;
    implementingAgentDetailsHeader = ViewApplicationProfessionalBodiesWamsConstants.IMPLEMENTING_AGENT_DETAILS_HEADER;
    engineerDisableFilterBy = true;
    engineerDisableEditing = true;
    engineerGroups = [];
    engineerLabel = ViewApplicationProfessionalBodiesWamsConstants.ENGINEER_LABEL;
    engineerDetailsHeader = ViewApplicationProfessionalBodiesWamsConstants.ENGINEER_DETAILS_HEADER;
    contractorDisableFilterBy = true;
    contractorDisableEditing = true;
    contractorGroups = [];
    contractorLabel = ViewApplicationProfessionalBodiesWamsConstants.RESPONSIBLE_CONTRACTOR_LABEL;
    contractorDetailsHeader = ViewApplicationProfessionalBodiesWamsConstants.CONTRACTOR_DETAILS_HEADER;
    selectedApplicationSubscription;
    selectedModuleNameAsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, recipientService, appController, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.recipientService = recipientService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToSelectedModuleName();
        this.listenForRouteParamChange();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.professionalBodiesFormControl);
        form.clearValidators();
        this.professionalBodiesForm = form;
    }
    loadMetadata(stepMeta) {
        try {
            this.implementingAgentGroups = stepMeta.implementingAgentConsultantGroup;
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.responsibleContractorGroup;
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
        this.listenForSelectedApplication();
        this.changeDetectorRef.detectChanges();
    }
    handleRouteChange() {
    }
    listenForSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.implementingAgent !== undefined && application.implementingAgent !== null && application.implementingAgent.length > 0) {
                    this.showImplementingAgent = true;
                    const implementingAgent = application.implementingAgent[0];
                    this.professionalBodiesForm.get(this.implementingAgentFormControlName).setValue(implementingAgent);
                    this.professionalBodiesForm.markAllAsTouched();
                }
                else {
                    this.professionalBodiesForm.get(this.implementingAgentFormControlName).disable();
                    this.professionalBodiesForm.markAllAsTouched();
                }
                if (application && application.engineer !== undefined && application.engineer !== null && application.engineer.length > 0) {
                    this.showEngineer = true;
                    const engineer = application.engineer[0];
                    this.professionalBodiesForm.get(this.engineerFormControlName).setValue(engineer);
                    this.professionalBodiesForm.markAllAsTouched();
                }
                else {
                    this.professionalBodiesForm.get(this.engineerFormControlName).disable();
                    this.professionalBodiesForm.markAllAsTouched();
                }
                if (application && application.contractor !== undefined && application.contractor !== null && application.contractor.length > 0) {
                    this.showContractor = true;
                    const electricalContractor = application.contractor[0];
                    this.professionalBodiesForm.get(this.contractorFormControlName).setValue(electricalContractor);
                    this.professionalBodiesForm.markAllAsTouched();
                }
                else {
                    this.professionalBodiesForm.get(this.contractorFormControlName).disable();
                    this.professionalBodiesForm.markAllAsTouched();
                }
            }
        });
    }
    subscribeToSelectedModuleName() {
        this.selectedModuleNameAsObservableSubscription = this.applicationViewService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${ViewApplicationConstants.PROFESSIONAL_BODIES_HEADING}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RecipientService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationProfessionalBodiesWamsComponent = __decorate([
    Component({
        selector: "app-view-application-professional-bodies-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationProfessionalBodiesWamsComponent);
export { ViewApplicationProfessionalBodiesWamsComponent };
